/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSpearHead: {
  name: 'spear_head';
  data: string;
} = {
  name: 'spear_head',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M466.796 284.883c-45.369 32.554-89.506 35.115-137.114 15.78.046-.82.075-1.644.075-2.475 0-23.903-19.379-43.281-43.281-43.281-4.194 0-8.243.608-12.078 1.721L40.901 23.721l-14.826.134-.009-.001.067 35.862 221.006 220.425a43.106 43.106 0 0 0-3.944 18.047c0 23.902 19.378 43.281 43.281 43.281 2.348 0 4.65-.193 6.896-.553 16.088 47.031 12.197 91.335-15.06 132.45 76.586 52.09 195.432 100.151 294.609 106.127 4.321-101.896-50.598-216.382-106.125-294.61z"/></svg>`,
};
